import {NavLogo} from '../Navbar/NavbarElements';
import {
  Icon,
  SidebarContainer,
  SidebarLink,
  SidebarMenu,
  SidebarWrapper,
  SubSidebarItem,
  SubSidebarLink,
  SubSidebarMenu
} from './SidebarElements';
import {SocialFollowBlack} from '../../../components/SocialFollow';
import "./sidebar.css";
import closeIcon from "./../../../assets/icons/close.png"
import logo from "../../../assets/Images/Main-Logo.png"

const Sidebar = ({isOpen, toggle, noToggle, close}) => {
  return (
    <SidebarContainer isOpen={isOpen} onClick={toggle}>
      <Icon onClick={close}>
        <img src={closeIcon} alt='close' width={30} height={'auto'}/>
      </Icon>
      <NavLogo to='/' onClick={close}><img src={logo} alt="logo" className='menu-logo'/></NavLogo>
      <SidebarWrapper>
        <SidebarMenu>
          <SidebarLink to="/" onClick={close}>Home</SidebarLink>
          <SubSidebarItem>
            <SidebarLink to="#" onClick={noToggle}>NFTs</SidebarLink>
            <SubSidebarMenu>
              <SubSidebarLink to="/allnfts" onClick={close}>All NFTs</SubSidebarLink>
              <SubSidebarLink to="/3D-Animations" onClick={close}>3D ANIMATION</SubSidebarLink>
              <SubSidebarLink to="/Bedrooms" onClick={close}>Bedrooms</SubSidebarLink>
              <SubSidebarLink to="/Mancaves" onClick={close}>Mancaves</SubSidebarLink>
              <SubSidebarLink to="/People" onClick={close}>People</SubSidebarLink>
            </SubSidebarMenu>
          </SubSidebarItem>
          <SidebarLink to="/about" onClick={close}>About</SidebarLink>
          <SidebarLink to="/roadmap" onClick={close}>Roadmap</SidebarLink>
          <SocialFollowBlack className="pl5"/>
        </SidebarMenu>
      </SidebarWrapper>
    </SidebarContainer>
  );
};

export default Sidebar;